import { render } from "./TabAttachment.vue?vue&type=template&id=12457a04"
import script from "./TabAttachment.vue?vue&type=script&lang=js"
export * from "./TabAttachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__